import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Ellipsis } from 'src/assets/images/ellipsis.svg';
import { ReactComponent as SearchIcon } from 'src/assets/images/search-icon.svg';
import { ReactComponent as SplitIcon } from 'src/assets/images/split-icon.svg';
import { orderSimulationRoute } from 'src/pages/order-simulation/route';
import styled from 'styled-components';
import { IItem, IOrder } from '../../graphql/types';
import { checkIfRetail } from '../../pages/order-details/order-summary-card';
import { availabilityRoute } from '../../pages/product-availability/route';
import { Medium } from '../../styles/fonts';
import { FormattedDate } from '../formatted-date/formatted-date';
import { Quantity } from '../quantity/quantity';
import { StatusBadge } from '../status-badge/status-badge';
import { IconTableCell, TD } from '../table/table';
import { TMSStatusBadge } from '../tms-status/tms-status';

const StyledText = styled.div`
  font-family: ${Medium};
`;

const StyledRow = styled.div`
  display: inline-flex;
  flex-direction: row;
  padding-right: 1rem;
`;

const SearchIconIconContainer = styled.div`
  margin: 0.25rem 0rem 0rem 1rem;
`;

const SplitOrderIconContainer = styled.div``;

export const highlightSplitOrders = (item: IItem): boolean => {
  const hasSplitDelivery = item.deliveries && item.deliveries.length > 1;
  const deliveriesWithConfirmedQuantities = item.deliveries.filter(
    schedule => schedule.quantity > 0
  );
  return hasSplitDelivery && deliveriesWithConfirmedQuantities.length > 1;
};

export const OrderItemData: FC<{ item: IItem; order: IOrder }> = ({
  item,
  order,
}) => {
  return (
    <>
      <IconTableCell data-type="split-order-icon">
        <SplitOrderIconContainer title="Split Order">
          {highlightSplitOrders(item) && <SplitIcon />}
        </SplitOrderIconContainer>
      </IconTableCell>
      <TD data-type="item-id">{item.index}</TD>
      <TD>
        <StyledText data-type="product-description">
          {item.product.description}
        </StyledText>
        <StyledRow>
          {order.soldTo.salesOrg === 'SG88' ||
          order.soldTo.salesOrg === 'US86' ||
          order.orderType === 'ZORD' ||
          checkIfRetail(order) ? (
            item.product.id
          ) : (
            <Link
              data-type="product-id"
              to={availabilityRoute(order.shipTo.id, {
                productId: item.product.id,
                plantId: item.plant.id,
              })}
            >
              {item.product.id}
            </Link>
          )}
          {!checkIfRetail(order) && (
            <Link
              to={orderSimulationRoute(order.soldTo.id, {
                shipToId: order.shipTo.id,
                productId: item.product.id,
                quantity: item.desiredQuantity.toString(),
              })}
            >
              <SearchIconIconContainer title="Order Simulation">
                <SearchIcon />
              </SearchIconIconContainer>
            </Link>
          )}
        </StyledRow>
      </TD>
      <TD data-type="product-desired-quantity">
        <Quantity
          quantity={item.desiredQuantity}
          unitOfMeasure={item.unitOfMeasure}
        />
      </TD>
      <TD data-type="product-actual-quantity">
        <Quantity
          quantity={item.actualQuantity}
          unitOfMeasure={
            item.deliveries.length > 0
              ? item.deliveries[0].unitOfMeasure
              : item.unitOfMeasure
          }
        />
      </TD>
      <TD data-type="product-backordered-quantity">
        <Quantity
          quantity={item.backorderedQuantity}
          unitOfMeasure={item.unitOfMeasure}
        />
      </TD>
      <TD data-type="product-first-date">
        <FormattedDate date={item.schedules[0].promiseDate} />
      </TD>
      <TD data-type="item-status">
        <StatusBadge status={item.status} />
      </TD>
      <TD data-type="tms-status">
        {item.deliveries.length === 1 &&
          item.deliveries[0].tmsOrKeplerDeliveryEvent && (
            <TMSStatusBadge
              status={item.deliveries[0].tmsOrKeplerDeliveryEvent.eventStatus}
            />
          )}
        {item.deliveries.length > 1 && (
          <span>Click ellipsis (three dots) for details</span>
        )}
        {(item.deliveries.length < 1 ||
          (item.deliveries.length === 1 &&
            !item.deliveries[0].tmsOrKeplerDeliveryEvent)) && <span>—</span>}
      </TD>
    </>
  );
};
